export default function Chart() {
    return <>Chart page</>
}